export default __webpack_public_path__ + "static/media/CourseDescriptionV3BG.7082acc7.png";